import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/erpsaude-relatorio-atendimento`
    const baseUrlFiltragem = `${baseUrl}/filtragem`

    return {
        index(queryParms) {
            return repository.get(`${baseUrl}?${urlUtil.serialize(queryParms)}`)
        },
        list(queryParms) {
            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
        autocomplete(queryParms) {
            return repository.get(`${baseUrl}/autocomplete?${urlUtil.serialize(queryParms)}`)
        },
        filtragemPorDiaSemana(queryParms) {
            return repository.get(`${baseUrlFiltragem}/dia-semana?${urlUtil.serialize(queryParms)}`)
        },
        filtragemPorTipoAlta(queryParms) {
            return repository.get(`${baseUrlFiltragem}/tipo-alta?${urlUtil.serialize(queryParms)}`)
        },
        filtragemPorProfissional(queryParms) {
            return repository.get(`${baseUrlFiltragem}/profissional?${urlUtil.serialize(queryParms)}`)
        },
        filtragemPorCid(queryParms) {
            return repository.get(`${baseUrlFiltragem}/cid?${urlUtil.serialize(queryParms)}`)
        },
    }
}